import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import {
  FilePdfOutlined,
} from '@ant-design/icons';
import date from '../helpers/date';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { spStates } from '../config/constants/contractStates';
import PropTypes from 'prop-types';

const { formatString } = date;

/**
 * Function that creates a downloadable pdf with list of documents
 * @param {Object} props Object with document data
 * @returns {Element} button.
 */
const DownloadListDocuments = ({ 
  listIsLoaded,
  validatedList,
  createdList,
  awaitingValidationList,
  sendedList,
  awaitingSignList,
  awaitingNotaryList,
  canceledList,
  objectedList,
  finalizedList,
  allList,
  activeTab
}) => {

  const [loaderSpinning, setLoaderSpinning] = useState(true);

  useEffect(() => {
    if (listIsLoaded) {
      setLoaderSpinning(false);
    };
  }, [listIsLoaded]);

  const downloadList = ({ ...data }) => {
    const columns = ['Nro', 'Id doc', 'Propietario', 'Rut', 'Fecha de creación', 'Id de compra', 'Monto', 'Estado'];
    const rows = data.data.map(
      (document, key) => (
        [
          key = key + 1,
          document.contractId,
          document.owner.nombre,
          document.owner.rut.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
          formatString(document.fecha),
          document.payment ? document.payment.buyOrder : 'NA',
          document.payment ? `$${document.payment.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}` : 'NA',
          spStates(document.estado),
        ]
      )
    );
    const doc = new jsPDF();
    doc.text(`Lista de documentos: ${data.list}`, 15, 20);
    doc.autoTable({
      startY: 30,
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 20 },
      },
      columns: columns,
      body: rows,
    });
    doc.save(`documentos_${data.list}.pdf`);
  };

  const setList = (activeTab) => {
    switch (activeTab) {
      case '0':
        downloadList({ list: 'Revisar', data: validatedList.docs });
        break;
      case '1':
        downloadList({ list: 'Pagados', data: createdList.docs });
        break;
      case '2':
        downloadList({ list: 'Por validar', data: awaitingValidationList.docs });
        break;
      case '3':
        downloadList({ list: 'Enviado a Notarisa', data: sendedList.docs });
        break;
      case '4':
        downloadList({ list: 'Por firmar', data: awaitingSignList.docs });
        break;
      case '5':
        downloadList({ list: 'En Notarisa', data: awaitingNotaryList.docs });
        break;
      case '6':
        downloadList({ list: 'Anulados', data: canceledList.docs });
        break;
      case '7':
        downloadList({ list: 'Objetados', data: objectedList.docs });
        break;
      case '8':
        downloadList({ list: 'Finalizados', data: finalizedList.docs });
        break;
      case '9':
        downloadList({ list: 'Todos', data: allList.docs });
        break;
      default:
        downloadList({ list: 'Revisar', data: validatedList.docs });
        break;
    }
  };

  return (
    <Button
      icon={<FilePdfOutlined />}
      onClick={() => setList(activeTab)}
      disabled={loaderSpinning}
      className="btn-responsive"
    >
      Descargar lista PDF
    </Button>
  );
};

DownloadListDocuments.propTypes = {
  listIsLoaded: PropTypes.bool.isRequired,
  validatedList: PropTypes.object.isRequired,
  createdList: PropTypes.object.isRequired,
  awaitingValidationList: PropTypes.object.isRequired,
  sendedList: PropTypes.object.isRequired,
  awaitingSignList: PropTypes.object.isRequired,
  awaitingNotaryList: PropTypes.object.isRequired,
  canceledList: PropTypes.object.isRequired,
  objectedList: PropTypes.object.isRequired,
  finalizedList: PropTypes.object.isRequired,
  allList: PropTypes.object.isRequired,
  activeTab: PropTypes.number.isRequired,
};

const data = (state) => ({
  listIsLoaded: state.contract.listIsLoaded,
});

export default connect(data, null)(DownloadListDocuments);